import { Feature } from '@/types/mapbox';

import { IPLocationData, formatLocationForGeocoding } from '@/utils/ipGeolocation';

/**
 * Convert IP location data to Mapbox Feature format
 * This allows IP-based location to work with existing address components
 */
export const convertIPLocationToMapboxFeature = (
  ipLocation: IPLocationData,
  id = 'ip-location'
): Feature => {
  // Use geocoding-optimized format for better Mapbox compatibility
  const fullAddress = formatLocationForGeocoding(ipLocation);
  
  return {
    type: 'Feature',
    id,
    geometry: {
      type: 'Point',
      coordinates: [ipLocation.longitude, ipLocation.latitude],
    },
    properties: {
      mapbox_id: id,
      full_address: fullAddress,
      place_formatted: fullAddress,
      name: fullAddress,
      name_preferred: fullAddress,
      feature_type: 'locality',
      coordinates: {
        accuracy: 'approximate',
        latitude: ipLocation.latitude,
        longitude: ipLocation.longitude,
        routable_points: [],
      },
      context: {
        address: { 
          mapbox_id: '', 
          name: '', 
          address: '', 
          street_name: '' 
        },
        country: { 
          mapbox_id: '', 
          name: ipLocation.country, 
          country_code: '', 
          country_code_alpha_3: '' 
        },
        district: { 
          mapbox_id: '', 
          name: '' 
        },
        place: { 
          mapbox_id: '', 
          name: ipLocation.city 
        },
        postcode: { 
          mapbox_id: '', 
          name: ipLocation.postal 
        },
        region: { 
          mapbox_id: '', 
          name: ipLocation.region, 
          region_code: '', 
          region_code_full: '' 
        },
        street: { 
          mapbox_id: '', 
          name: '' 
        },
      },
      match_code: {
        address_number: '',
        confidence: 'approximate',
        country: 'approximate',
        locality: 'high',
        place: 'high',
        postcode: ipLocation.postal ? 'approximate' : '',
        region: 'high',
        street: '',
      },
    },
  };
};